import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import VisitAverageAttendanceActions, { VisitAverageAttendanceRedux, VisitAverageAttendanceTypes } from '../Redux/VisitAverageAttendanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const visitAverageAttendanceCrudObservable = createCRUDObservable({
  mainRedux: VisitAverageAttendanceRedux,
  reduxPath: 'visitAverageAttendance',
})

const visitAverageAttendanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(VisitAverageAttendanceTypes.VisitAverageAttendanceExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.visitAverageAttendance.getVisitAverageAttendanceExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            VisitAverageAttendanceActions.VisitAverageAttendanceExcelSuccess(),
          ]
        })
    ))

export const visitAverageAttendanceObservers = Object.assign({}, visitAverageAttendanceCrudObservable.observers, {})

export const visitAverageAttendanceEpic = combineEpics(
  visitAverageAttendanceCrudObservable.epic,
  visitAverageAttendanceExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/VisitAverageAttendanceObservable.js